import { addDays } from 'date-fns';
import { useCallback } from 'react';
import type { CalendarEvent } from '../types';

export const useGetAllDayEventsForDay = <T extends CalendarEvent>({ events }: { events: T[] }) =>
  useCallback(
    ({ day }: { day: Date }) => {
      const dayStart = new Date(day);
      dayStart.setHours(0, 0, 0, 0);

      const nextDayStart = addDays(dayStart, 1);

      return events.filter((event) => event.isAllDay && event.start < nextDayStart && event.end > dayStart);
    },
    [events],
  );
